import * as React from 'react';
import { FC } from 'react';
import { connect } from 'react-redux';
import Form from '../../components/auth/ResetFormEmail';
import { sendResetEmail } from "~/apps/shared/actions/passwordReset";
import Loader from "~/common/components/Loader";

const ResetFormEmail: FC<any> = props => {
  const { passwordReset, dispatch } = props;

  const onSubmit = (values) => {
    dispatch(sendResetEmail(values))
  }

  if (passwordReset.loading) {
    return  <Loader className="load--ol" />;
  }

  return (
    <Form
      onSubmit={onSubmit}
      error={passwordReset.errorMessage}
      submitting={passwordReset.loading}
      success={passwordReset.successReset}
    />
  );
}

const mapStateToProps = (state) => {
  return {
    passwordReset: state.shared.passwordReset,
  }
}

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetFormEmail);
